import _ from 'lodash';
import { Profile } from '.';

export const getContext = (state: any) => _.get(state, 'auth', {});

export const getAuthStatus: string | any = (state: any) =>
  _.get(getContext(state), 'status', false);
export const getProfile: Profile | any = (state: any) => getContext(state).profile;
export const getUserRoles: string[] | any = (state: any) => _.get(getContext(state), 'roles', []);
